import React, { useMemo } from 'react';

import AddDataConnectionSelectDataSourceStep from '@palette/components/planV3/DataSources/AddDataConnectionSelectDataSourceStep/AddDataConnectionSelectDataSourceStep';
import AddDataConnectionSelectDataStepManagement from '@palette/components/planV3/DataSources/AddDataConnectionSelectDataStepManagement/AddDataConnectionSelectDataStepManagement';

import { useAddDataConnectionStepValue } from '@palette/hooks/PlanV3Hooks';

import { ADD_DATA_CONNECTION_FLOW_STEPS } from '@palette/constants/notebooks';

const AddDataConnectionFlowPageStepsManagement = () => {
  const addDataConnectionFlowStepsNodes = useMemo(() => ({
    [ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA_SOURCE.value]: () => (
      <AddDataConnectionSelectDataSourceStep />
    ),
    [ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA.value]: () => (
      <AddDataConnectionSelectDataStepManagement />
    ),
  }), []);

  const addDataConnectionStepValue = useAddDataConnectionStepValue();

  const stepNode = useMemo(() => {
    switch (addDataConnectionStepValue) {
      case ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA_SOURCE.value: {
        return addDataConnectionFlowStepsNodes[ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA_SOURCE.value]();
      }
      case ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA.value: {
        return addDataConnectionFlowStepsNodes[ADD_DATA_CONNECTION_FLOW_STEPS.SELECT_DATA.value]();
      }
      default:
        return null;
    }
  }, [addDataConnectionStepValue, addDataConnectionFlowStepsNodes]);

  return stepNode;
};

export default AddDataConnectionFlowPageStepsManagement;
